import React from "react";
import FormField from "../components/FormField";

export default function Step6DamageInfo({ data, onChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">
        خسارت تأخیر در انجام تعهدات
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        در صورت تأخیر هر یک از طرفین در انجام تعهدات، معادل ده درصد ثمن معامله به عنوان خسارت پرداخت می‌گردد.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4">
        <FormField
          label="توضیحات تکمیلی خسارت"
          name="penaltyDescription"
          type="textarea"
          value={data.penaltyDescription}
          onChange={onChange}
          placeholder="مثلاً به ازای هر روز تأخیر در تحویل خودرو یا اسناد، طرف متخلف موظف به پرداخت مبلغ فوق به طرف مقابل است."
          full
          rows={4}
        />
      </div>
    </div>
  );
}
